
import * as Rest from "../../Generated/RestClient";

export const MAX_NAME_LEN = 35;
export const MIN_NAME_LEN = 1;
export const MAX_ID_LEN = 35;
export const MIN_ID_LEN = 4;
export const MAX_DESC_LEN = 512;

export interface ErrorDict {
    [fieldName: string]: string;
}

export interface IBotEditor {
    handleChange: (fieldName: string, ev) => void;
    handleArrayChange: (fieldName: string, ev) => void;
    state: { bot?: Rest.BotService, errors?: ErrorDict };
}



// WEBPACK FOOTER //
// ./Client/Views/Shared/IBotEditor.ts